<template>
  <Light class="light--yellow" :style="{ 'background-color': backgroundColor }"/>
</template>

<script>
  import Light from './Light';
  import {convertBrightness} from '../../utils';

  export default {
    name: 'YellowLight',
    components: {
      Light
    },
    props: [
      'brightness'
    ],
    computed: {
      backgroundColor() {
        return `rgba(255, 255, 0, ${convertBrightness(this.brightness)})`;
      }
    }
  };
</script>

<style>
  .light--yellow {
    border-color: yellow;
  }
</style>
